export enum EnumFormType {
    List = 0,
    New = 1,
    Edit = 2,
    Details = 3,
    Duplicate = 4,
    Desconhecido = 99
}
